import { useMemo } from 'react';
import Fuse from 'fuse.js';
const properties = require("@icarius-utils/properties");

export default function useCommandSearch(formattedRoutes, query) {
  const fuse = useMemo(() => {
    const searchKeys = ['label', 'searchLabelSpacing', 'searchLabelNoSpacing'];

    if (properties['SEARCH_BY_PATH'] === true) {
      searchKeys.push('path');
    }

    return new Fuse(formattedRoutes, {
      keys: searchKeys,
      includeMatches: true,
      includeScore: true,
      threshold: 0.3,
      ignoreLocation: true,
      ignoreDiacritics: true,
      minMatchCharLength: 2,
      findAllMatches: true,
    });
  }, [formattedRoutes]);

  const results = useMemo(() => {
    if (!query) {
      return formattedRoutes.map(item => ({ item, matches: [] }));
    }
    const searchResults = fuse.search(query);
    return searchResults.sort((a, b) => {
      if (a.score !== b.score) {
        return a.score - b.score; // Fuse.js uses lower score for better matches
      }
      return a.item.label.localeCompare(b.item.label);
    });
  }, [query, formattedRoutes, fuse]);

  return results;
}
